import { ApplicantTabId } from '@/components/pages/Applicant/Applicant.types';

export const DEEP_LINK_TARGETS = {
    conditionId: { label: 'task/condition', tab: ApplicantTabId.Conditions },
    noteId: { label: 'note', tab: ApplicantTabId.Activity },
    nmiId: { label: 'information request', tab: ApplicantTabId.Activity },
} as const;

export type DeepLinkTargetParam = keyof typeof DEEP_LINK_TARGETS;

export const deepLinkPendingCopy = (label: string) => `Opening ${label}...`;

export const deepLinkMissingCopy = (label: string) =>
    `Couldn't find that ${label} on this application.`;
